import { cn } from '@repo/ui/utils'
import { ReactNode, useMemo } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'

import { AdminMenu } from '@/components/admin/AdminMenu'
import { AssistantWrapper } from '@/components/assistant/AssistantWrapper'
import { BeneficiaryListAsSheetProvider } from '@/components/beneficiary/list/sheet/BeneficiaryListAsSheet'
import { Navbar } from '@/components/layouts/Navbar'
import { LeftPanel } from '@/components/layouts/panels/LeftPanel'
import { RightPanel } from '@/components/layouts/panels/RightPanel'
import { useBreakpoint } from '@/hooks'
import { isRoute, RouteNames, SearchParamsKeyNames } from '@/routes'

export function LayoutManager({ children }: { children: ReactNode }) {
  const { isShortViewport } = useBreakpoint()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const currentKey = searchParams.get(SearchParamsKeyNames.View)
  const pathname = useMemo(() => location.pathname, [location.pathname])
  const isAdminRoute = useMemo(() => isRoute(RouteNames.Admin, pathname), [pathname])

  if (isAdminRoute) {
    return (
      <LayoutContainer className="flex-row ">
        <LeftPanel status="fixed" className="p-4 pr-0 2xl:p-6 2xl:pr-0">
          <AdminMenu currentKey={currentKey} keyName={SearchParamsKeyNames.View} />
        </LeftPanel>

        <div className="flex flex-1 flex-col overflow-hidden min-h-screen p-4 2xl:p-6 overflow-y-auto">
          {children}
        </div>
      </LayoutContainer>
    )
  } else if (isShortViewport)
    return (
      <LayoutContainer className="flex-col p-2">
        <Navbar isShort />

        <div className="flex flex-1 flex-col overflow-hidden overflow-y-auto">{children}</div>
      </LayoutContainer>
    )
  else
    return (
      <LayoutContainer>
        <div className="flex flex-1 flex-col p-4 2xl:py-6">
          <Navbar />
          <div className="flex flex-1 flex-col overflow-hidden">{children}</div>
        </div>

        <RightPanel status="fixed">
          <AssistantWrapper />
        </RightPanel>
      </LayoutContainer>
    )
}

function LayoutContainer({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <BeneficiaryListAsSheetProvider>
      <div className={cn('relative z-10 flex h-screen w-screen overflow-hidden', className)}>
        {children}
      </div>
    </BeneficiaryListAsSheetProvider>
  )
}
